import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Construtora = () => {
  const wpp = generateWhatsAppLink('construtora', 'construtora-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Construtoras | Sustenta LED</title>
        <meta name="description" content="Soluções LED para construtoras. Somos atacadistas e distribuidores com suporte técnico e logística para obras." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Construtoras</h1>
              <p>Atendemos construtoras com produtos LED para obras residenciais, comerciais e industriais. Somos atacadistas e distribuidores com portfólio completo e prazos confiáveis.</p>
              <p>Orientamos especificações técnicas conforme projeto, oferecendo eficiência, segurança e estética adequada para cada ambiente.</p>
              <p>Receba atendimento consultivo e condições especiais para obras em andamento.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_quemsomos_sustentaled.jpg" alt="LED para Construtoras - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Construtora;
